module.exports = __webpack_public_path__ + "img/rsz_img_20211107_101247.57d0dc91.jpg";